import pieces from '../data/irisPieces.json';

const EASE_IN = 'cubic-bezier(0.22, 1, 0.36, 1)';
const EASE_EXPAND = 'cubic-bezier(0.7, 0, 0.25, 1)';

export default function IrisAssembly({ color = 'yellow', fast = false, label, labelColor = '#ffffff', size = 210 }) {
  const cfg = fast
    ? { start: 0.08, gap: 0.09, dur: 0.55, total: 1.7, labelDur: 0.7 }
    : { start: 0.15, gap: 0.14, dur: 0.85, total: 2.6, labelDur: 1.0 };
  const assembled = cfg.start + cfg.gap * (pieces.length - 1) + cfg.dur;

  return (
    <div
      className="relative"
      data-testid="iris-assembly"
      style={{
        width: size,
        height: size,
        animation: `irisExpand ${cfg.total}s ${EASE_EXPAND} both`,
      }}
    >
      <div
        aria-hidden="true"
        className="absolute -inset-10 rounded-full"
        style={{
          background: `radial-gradient(circle, ${labelColor === '#ffffff' ? 'rgba(255,206,0,0.28)' : labelColor + '33'} 0%, transparent 65%)`,
          opacity: 0,
          animation: `irisGlow 0.6s ease-out ${assembled - 0.1}s both`,
        }}
      />

      {pieces.map((p, i) => (
        <img
          key={i}
          src={`${p.src}${color}.png`}
          alt=""
          draggable={false}
          className="absolute inset-0 h-full w-full select-none"
          style={{
            '--px': `${p.x}px`,
            '--py': `${p.y}px`,
            '--pr': `${p.r}deg`,
            opacity: 0,
            animation: `irisPieceIn ${cfg.dur}s ${EASE_IN} ${cfg.start + i * cfg.gap}s both`,
          }}
        />
      ))}

      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0"
        style={{
          WebkitMaskImage: `url(/assets/iris-${color}.png)`,
          maskImage: `url(/assets/iris-${color}.png)`,
          WebkitMaskSize: 'contain',
          maskSize: 'contain',
          WebkitMaskRepeat: 'no-repeat',
          maskRepeat: 'no-repeat',
          WebkitMaskPosition: 'center',
          maskPosition: 'center',
        }}
      >
        <div
          className="absolute inset-y-0 w-1/3"
          style={{
            background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)',
            transform: 'translateX(-130%)',
            animation: `irisShine 0.55s ease-in-out ${assembled + 0.05}s both`,
          }}
        />
      </div>

      {label && (
        <div
          className="absolute -bottom-16 left-1/2 whitespace-nowrap font-heading text-sm font-bold uppercase tracking-[0.5em]"
          style={{
            color: labelColor,
            opacity: 0,
            animation: `irisLabel ${cfg.labelDur}s ease ${assembled - 0.05}s both`,
          }}
        >
          {label}
        </div>
      )}
    </div>
  );
}
